import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Servicios.css';

const stepsPersonal = [
  { icon: 'fa-solid fa-user-plus',          label: 'Crea tu cuenta' },
  { icon: 'fa-solid fa-file-signature',     label: 'Completa perfil' },
  { icon: 'fa-solid fa-hand-holding-dollar', label: 'Recibe respuesta' },
];

const stepsGarantia = [
  { icon: 'fa-solid fa-handshake',      num: 1, title: 'Permítanos conocerlo',   desc: 'Acérquese a nuestros locales y porte su DNI.' },
  { icon: 'fa-solid fa-gem',            num: 2, title: 'Presente su garantía',   desc: 'Personal calificado le dará la mejor tasación.' },
  { icon: 'fa-solid fa-file-pen',       num: 3, title: 'Firme su contrato',      desc: 'Lo guiaremos en cada paso del llenado.' },
  { icon: 'fa-solid fa-money-bill-wave',num: 4, title: 'Reciba su préstamo',     desc: 'De inmediato y sin demoras innecesarias.' },
  { icon: 'fa-solid fa-ring',           num: 5, title: 'Recupere su garantía',   desc: 'Cancelado el préstamo, recupera su bien.' },
];

const garantias = [
  {
    img: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?auto=format&fit=crop&q=80&w=400',
    icon: 'fa-solid fa-laptop',
    title: 'Electrónicos',
    desc: 'Smartphones, laptops, tablets y todo dispositivo electrónico.',
  },
  {
    img: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80&w=400',
    icon: 'fa-solid fa-plug',
    title: 'Electrodomésticos',
    desc: 'Refrigeradoras, lavadoras, televisores y más.',
  },
  {
    img: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?auto=format&fit=crop&q=80&w=400',
    icon: 'fa-solid fa-gem',
    title: 'Joyas de Oro',
    desc: 'Collares, anillos, aretes y toda joya de oro valorada.',
  },
  {
    img: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&q=80&w=400',
    icon: 'fa-solid fa-motorcycle',
    title: 'Motocicletas',
    desc: 'Tu moto o bicicleta como respaldo para tu dinero.',
  },
];

const Servicios = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* Product Divider */}
      <div className="product-divider">
        <div className="div-rule"></div>
        <div className="div-title">Nuestros Servicios</div>
        <div className="div-rule"></div>
      </div>

      <section id="servicios" className="servicios">
        {/* ── Modalidad 01: Préstamo Personal DNI ── */}
        <div className="servicios__personal-grid">
          <div>
            <div className="eyebrow">Modalidad 01</div>
            <h2 className="section-title" style={{ textAlign: 'left' }}>
              Préstamo Personal con DNI
            </h2>
            <p className="servicios__desc">
              Obtén liquidez inmediata con un proceso 100% digital. Solo necesitas
              tu DNI para evaluación.
            </p>
            <ul className="servicios__req-list">
              <li><span className="req-check">✓</span> DNI vigente (Perú)</li>
              <li><span className="req-check">✓</span> Cuenta bancaria propia</li>
              <li><span className="req-check">✓</span> Evaluación rápida y segura</li>
            </ul>
          </div>

          <div>
            <h3 className="servicios__sub-title">Solicita tu Crédito</h3>
            <div className="servicios__underline"></div>
            <div className="steps-row">
              {stepsPersonal.map((s, i) => (
                <React.Fragment key={s.label}>
                  <div className="step-box">
                    <div className="step-number">Paso {i + 1}</div>
                    <div className="step-icon-wrap">
                      <i className={s.icon}></i>
                    </div>
                    <div className="step-text"><h4>{s.label}</h4></div>
                  </div>
                  {i < stepsPersonal.length - 1 && (
                    <div className="step-arrow"><i className="fa-solid fa-chevron-right"></i></div>
                  )}
                </React.Fragment>
              ))}
            </div>
            <button className="servicios__cta" onClick={() => navigate('/register')}>
              <i className="fa-solid fa-user-plus"></i> Crear cuenta gratis
            </button>
          </div>
        </div>

        <div className="servicios__divider"></div>

        {/* ── Modalidad 02: Garantía Prendaria ── */}
        <div className="servicios__garantia-header">
          <div className="eyebrow">Modalidad 02</div>
          <h2 className="section-title">Préstamo con Garantía Prendaria</h2>
          <p className="servicios__desc" style={{ maxWidth: 700, margin: '0 auto' }}>
            Obtén liquidez inmediata dejando un bien en garantía. Contamos con
            tasadores certificados y bóvedas de alta seguridad.
          </p>
        </div>

        {/* 5-step process */}
        <div className="steps-row steps-row--wrap">
          {stepsGarantia.map((s, i) => (
            <React.Fragment key={s.num}>
              <div className="step-box">
                <div className="step-number">Paso {s.num}</div>
                <div className="step-icon-wrap">
                  <i className={s.icon}></i>
                </div>
                <div className="step-text">
                  <h4>{s.title}</h4>
                  <p>{s.desc}</p>
                </div>
              </div>
              {i < stepsGarantia.length - 1 && (
                <div className="step-arrow"><i className="fa-solid fa-chevron-right"></i></div>
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Guarantee cards + Form */}
        <div className="servicios__garantia-grid">
          <div>
            <h3 className="servicios__sub-title">Garantías que aceptamos</h3>
            <div className="servicios__underline"></div>
            <div className="gar-cards">
              {garantias.map((g) => (
                <div className="gar-card" key={g.title}>
                  <div className="gar-img" style={{ backgroundImage: `url('${g.img}')` }}>
                    <div className="gar-icon-float"><i className={g.icon}></i></div>
                  </div>
                  <div className="gar-info">
                    <h4>{g.title}</h4>
                    <p>{g.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="form-card">
            <h3 style={{ marginBottom: 10, fontFamily: 'Syne' }}>¿Quieres tasar un bien?</h3>
            <div className="servicios__underline"></div>
            <div className="form-field">
              <label>Tipo de bien</label>
              <select>
                <option>Oro / Joyas</option>
                <option>Electrónicos (Laptop/Celular)</option>
                <option>Electrodomésticos</option>
                <option>Vehículos (Motos/Bicis)</option>
              </select>
            </div>
            <div className="form-field">
              <label>Descripción del bien</label>
              <textarea placeholder="Ej: Laptop MacBook Air 2022, estado 9/10"></textarea>
            </div>
            <button className="btn-submit">Consultar Tasación Gratis</button>
            <p className="form-note">Respuesta inmediata vía WhatsApp</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Servicios;
